<div class="cm-landing-fixed-width cm-hero-section">
	<div class="cm-hero-section__left">
		<h1>
			Research Studies
		</h1>
		<p>
			See how CropManage performs in the field
		</p>
	</div>
	<div class="cm-hero-section__right">
		<img src="../../../../assets/images/photos/field-work.jpg" width="659" height="366"/>
	</div>
</div>

<div class="cm-landing-fixed-width cm-grid cm-grid__section-a">
	<h2>Proven Results in the Field</h2>
	<p>Peer-reviewed studies by University of California researchers show
		how CropManage helps save water, reduce fertilizer use, and maintain
		yields.</p>
	<div class="cm-studies">
		<div class="cm-study">
			<h3>Cauliflower growers cut water use by 41% without lowering yield</h3>
			<ul>
				<li>Tested 50%, 75%, 100%, and 150% crop ET irrigation levels.</li>
				<li>100% ET treatment maximized yield and irrigation productivity.</li>
				<li>Saved an average of 41% water compared to grower practice.</li>
			</ul>
			<div class="cm-study__metadata-group">
				<div class="cm-study__metadata">
					<mat-icon>
						article
					</mat-icon>
					<div class="cm-study__title">
						Evapotranspiration-Based Irrigation Management Effects
						on Yield and...
					</div>
				</div>
				<div class="cm-study__metadata">
					<mat-icon>
						calendar_today
					</mat-icon>
					2025
				</div>
			</div>
			<a href="../../../../assets/pdf/Evapotranspiration Based Irrigation Management.pdf" target="_blank">read full study</a>
		</div>
		<div class="cm-study">
			<h3>Lettuce growers reduced nitrogen by 31% while maintaining yield</h3>
			<ul>
				<li>Nitrogen fertilizer reduced by 31% without affecting yield.</li>
				<li>Over 25% water savings with CropManage irrigation recommendations.</li>
			</ul>
			<div class="cm-study__metadata-group">
				<div class="cm-study__metadata">
					<mat-icon>
						article
					</mat-icon>
					<div class="cm-study__title">
						Field Evaluations of the CropManage Decision Support Tool
						for Improving...
					</div>
				</div>
				<div class="cm-study__metadata">
					<mat-icon>
						calendar_today
					</mat-icon>
					2023
				</div>
			</div>
			<a href="../../../../assets/pdf/Field Evaluations of the CropManage.pdf" target="_blank">read full study</a>
		</div>
		<div class="cm-study">
			<h3>Higher water efficiency in romaine lettuce trials</h3>
			<ul>
				<li>100% ET replacement gave the highest efficiency.</li>
				<li>Used 30–50% less water than grower standard.</li>
			</ul>
			<div class="cm-study__metadata-group">
				<div class="cm-study__metadata">
					<mat-icon>
						article
					</mat-icon>
					<div class="cm-study__title">
						Evapotranspiration-Based Irrigation Trials Examine Water
						Requirement...
					</div>
				</div>
				<div class="cm-study__metadata">
					<mat-icon>
						calendar_today
					</mat-icon>
					2022
				</div>
			</div>
			<a href="../../../../assets/pdf/Evapotranspiration Based Irrigation Trials.pdf" target="_blank">read full study</a>
		</div>
		<div class="cm-study">
			<h3>Affordable sensors automate irrigation tracking in CropManage</h3>
			<ul>
				<li>Developed an Arduino-based datalogger for monitoring
					irrigation water use.</li>
				<li>Designed to integrate with CropManage for automated
					record keeping.</li>
				<li>
					Reduces cost barriers for farms without high-end
					metering equipment.
				</li>
			</ul>
			<div class="cm-study__metadata-group">
				<div class="cm-study__metadata">
					<mat-icon>
						article
					</mat-icon>
					<div class="cm-study__title">
						A Low-Cost Arduino-Based Datalogger with Cellular Modem 
						and FTP...
					</div>
				</div>
				<div class="cm-study__metadata">
					<mat-icon>
						calendar_today
					</mat-icon>
					2019
				</div>
			</div>
			<a href="../../../../assets/pdf/A Low Cost Arduino.pdf" target="_blank">read full study</a>
		</div>
		<div class="cm-study">
			<h3>Broccoli and lettuce yield maintained with less water</h3>
			<ul>
				<li>100% ET application matched or exceeded grower results.</li>
				<li>Resulted in less water use without yield loss.</li>
			</ul>
			<div class="cm-study__metadata-group">
				<div class="cm-study__metadata">
					<mat-icon>
						article
					</mat-icon>
					<div class="cm-study__title">
						Evapotranspiration-Based Irrigation Scheduling of Head
						Lettuce and...
					</div>
				</div>
				<div class="cm-study__metadata">
					<mat-icon>
						calendar_today
					</mat-icon>
					2016
				</div>
			</div>
			<a href="../../../../assets/pdf/ET Based Irrigation Scheduling of Head Lettuce.pdf" target="_blank">read full study</a>
		</div>
	</div>
</div>

<div class="cm-grid__section-b">
	<div class="cm-landing-fixed-width cm-grid">
		<h2>Research Behind the Algorithms</h2>
		<p>Peer-reviewed research provides the models that underpin CropManage’s
			irrigation and nutrient recommendations.</p>
		<div class="cm-studies">
			<div class="cm-study">
				<h3>Soil Evaporation Model</h3>
				<p>
					Introduced a method to estimate how soil dries after irrigation or rain
				</p>
				<div class="cm-study__metadata-group">
					<div class="cm-study__metadata">
						<mat-icon>
							article
						</mat-icon>
						<div class="cm-study__title">
							Penman for All Seasons
						</div>
					</div>
					<div class="cm-study__metadata">
						<mat-icon>
							calendar_today
						</mat-icon>
						1986
					</div>
				</div>
				<a href="https://ascelibrary.org/doi/10.1061/%28ASCE%290733-9437%281986%29112%3A4%28348%29" target="_blank">read full study</a>
			</div>
			<div class="cm-study">
				<h3>Water Stress Model</h3>
				<p>
					Defines how crops reduce water use when soil moisture becomes limited.
				</p>
				<div class="cm-study__metadata-group">
					<div class="cm-study__metadata">
						<mat-icon>
							article
						</mat-icon>
						<div class="cm-study__title">
							Crop Evapotranspiration: Guidelines for Computing Crop
							Water...
						</div>
					</div>
					<div class="cm-study__metadata">
						<mat-icon>
							calendar_today
						</mat-icon>
						1998
					</div>
				</div>
				<a href="https://www.fao.org/4/x0490e/x0490e00.htm" target="_blank">read full study</a>
			</div>
			<div class="cm-study">
				<h3>Almond Nitrogen Uptake</h3>
				<p>
					Shows how and when almonds take up nitrogen during the season.
				</p>
				<div class="cm-study__metadata-group">
					<div class="cm-study__metadata">
						<mat-icon>
							article
						</mat-icon>
						<div class="cm-study__title">
							Regulation of Nitrogen Partitioning in Field-Grown
							Almond Trees: Effects... 
						</div>
					</div>
					<div class="cm-study__metadata">
						<mat-icon>
							calendar_today
						</mat-icon>
						2011
					</div>
				</div>
				<a href="https://www.researchgate.net/publication/226619164_Regulation_of_nitrogen_partitioning_in_field-grown_almond_trees_Effects_of_fruit_load_and_foliar_nitrogen_applications"
					target="_blank">read full study</a>
			</div>
			<div class="cm-study">
				<h3>Crop Coefficients</h3>
				<p>
					Developed crop-specific water use curves for vegetables in
					California.
				</p>
				<div class="cm-study__metadata-group">
					<div class="cm-study__metadata">
						<mat-icon>
							article
						</mat-icon>
						<div class="cm-study__title">
							Efficient Nitrogen Fertility and Irrigation Management
							of Cool-Season... 
						</div>
					</div>
					<div class="cm-study__metadata">
						<mat-icon>
							calendar_today
						</mat-icon>
						2017
					</div>
				</div>
				<a href="../../../../assets/pdf/Efficient Nitrogen Fertility.pdf" target="_blank">read full study</a>
			</div>
			<div class="cm-study">
				<h3>Satellite Canopy Measurement</h3>
				<p>
					Describes how satellite imagery is used to measure crop
					canopy size, helping users verify and adjust crop growth
					curves in CropManage.
				</p>
				<div class="cm-study__metadata-group">
					<div class="cm-study__metadata">
						<mat-icon>
							article
						</mat-icon>
						<div class="cm-study__title">
							Satellite NDVI Assisted Monitoring of Vegetable Crop 
							Evapotranspiration...
						</div>
					</div>
					<div class="cm-study__metadata">
						<mat-icon>
							calendar_today
						</mat-icon>
						2012
					</div>
				</div>
				<a href="../../../../assets/pdf/Satellite NDVI Assisted Monitoring.pdf" target="_blank">read full study</a>
			</div>
		</div>
	</div>
</div>
